module.exports = __webpack_public_path__ + "img/star.4a9ce627.svg";